/**
 * @generated SignedSource<<a17842a78581abd6de3257052ed89dd0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type HelpCenterNavigationBarBorderType = "ALL_BORDER" | "BOTTOM_BORDER" | "NO_BORDER" | "%future added value";
export type HelpCenterNavigationBarPositionType = "FIXED" | "FLOATING" | "%future added value";
export type HelpCenterType = "ADVANCED" | "BASIC" | "CUSTOMER_SERVICE" | "HELP_HUB" | "UNIFIED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference$data = {
  readonly helpCenterById: {
    readonly helpCenterBranding?: {
      readonly colors: {
        readonly primary: string | null | undefined;
      } | null | undefined;
      readonly logo: {
        readonly fileId: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined;
      readonly navigationBar: {
        readonly backgroundColor: string | null | undefined;
        readonly borderColor: string | null | undefined;
        readonly borderType: HelpCenterNavigationBarBorderType | null | undefined;
        readonly cornerRadius: number | null | undefined;
        readonly padding: boolean | null | undefined;
        readonly positionType: HelpCenterNavigationBarPositionType | null | undefined;
        readonly textColor: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly type?: HelpCenterType | null | undefined;
  } | null | undefined;
  readonly hubMediaConfig: {
    readonly asapIssuer: string;
    readonly mediaCollectionName: string;
    readonly mediaToken: string;
    readonly mediaUrl: string;
  };
  readonly pageMediaConfig?: {
    readonly asapIssuer: string | null | undefined;
    readonly mediaCollectionName: string | null | undefined;
    readonly mediaToken: string | null | undefined;
    readonly mediaUrl: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference";
};
export type hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference$key = {
  readonly " $data"?: hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference$data;
  readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "operationType",
  "variableName": "operationType"
},
v1 = {
  "kind": "ScalarField",
  "name": "asapIssuer"
},
v2 = {
  "kind": "ScalarField",
  "name": "mediaCollectionName"
},
v3 = {
  "kind": "ScalarField",
  "name": "mediaToken"
},
v4 = {
  "kind": "ScalarField",
  "name": "mediaUrl"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hubAri"
    },
    {
      "kind": "RootArgument",
      "name": "operationType"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "pageAri"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "skipPageMediaConfig"
    }
  ],
  "kind": "Fragment",
  "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "args": [
          {
            "kind": "Variable",
            "name": "ari",
            "variableName": "hubAri"
          },
          (v0/*: any*/)
        ],
        "concreteType": "HelpCenterMediaConfig",
        "kind": "LinkedField",
        "name": "hubMediaConfig",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v1/*: any*/),
            "action": "THROW",
            "path": "hubMediaConfig.asapIssuer"
          },
          {
            "kind": "RequiredField",
            "field": (v2/*: any*/),
            "action": "THROW",
            "path": "hubMediaConfig.mediaCollectionName"
          },
          {
            "kind": "RequiredField",
            "field": (v3/*: any*/),
            "action": "THROW",
            "path": "hubMediaConfig.mediaToken"
          },
          {
            "kind": "RequiredField",
            "field": (v4/*: any*/),
            "action": "THROW",
            "path": "hubMediaConfig.mediaUrl"
          }
        ]
      },
      "action": "THROW",
      "path": "hubMediaConfig"
    },
    {
      "condition": "skipPageMediaConfig",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": "pageMediaConfig",
          "args": [
            {
              "kind": "Variable",
              "name": "ari",
              "variableName": "pageAri"
            },
            (v0/*: any*/)
          ],
          "concreteType": "HelpCenterMediaConfig",
          "kind": "LinkedField",
          "name": "hubMediaConfig",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/)
          ]
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "helpCenterAri",
          "variableName": "hubAri"
        }
      ],
      "kind": "LinkedField",
      "name": "helpCenterById",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "type"
            },
            {
              "concreteType": "HelpCenterBranding",
              "kind": "LinkedField",
              "name": "helpCenterBranding",
              "plural": false,
              "selections": [
                {
                  "concreteType": "HelpCenterLogo",
                  "kind": "LinkedField",
                  "name": "logo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "fileId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url"
                    }
                  ]
                },
                {
                  "concreteType": "HelpCenterBrandingColors",
                  "kind": "LinkedField",
                  "name": "colors",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "primary"
                    }
                  ]
                },
                {
                  "concreteType": "HelpCenterNavigationBar",
                  "kind": "LinkedField",
                  "name": "navigationBar",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "backgroundColor"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "borderColor"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "borderType"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "cornerRadius"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "padding"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "positionType"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "textColor"
                    }
                  ]
                }
              ]
            }
          ],
          "type": "HelpCenter"
        }
      ]
    }
  ],
  "type": "HelpCenterQueryApi"
};
})();

(node as any).hash = "18d33d7e0c74ef6a049b65dc6308e091";

export default node;
